module.exports = "/_next/static/images/video-frame-ec7a183e6d2da56656d3680120b3a98c.png";